import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `AjusteStock/imprimirAjusteStock`, method: 'POST', body: list, token: token})
}